<!-- 公司基础信息 -->
<template>
    <div class="container">
        <Form :model="formData" label-position="right" :label-width="130">
            <FormItem label="公司名称：">
                <Input class="w300" type="text" v-model="formData.company_name" placeholder="请输入公司名称"></Input>
            </FormItem>
            <FormItem label="公司logo：">
                <div class="image-div mb24">
                    <div class="form_upload mr24 " @click="openModal(1)">
                        <Icon type="ios-add" size="40" color="#AEAEB3"/>
                    </div>
                    <div v-if="formData.show_logo" class="form_upload position_relative">
                        <Icon class="form_icon" size="20" type="ios-close-circle" color="#f00" @click.stop="delImg(1)"/>
                        <img class="form_img" :src="formData.show_logo" @click="previewImg(formData.show_logo)">
                    </div>
                </div>
            </FormItem>
            <FormItem label="营业执照：">
                <div class="image-div mb24">
                    <div class="form_upload mr24 " @click="openModal(2)">
                        <Icon type="ios-add" size="40" color="#AEAEB3"/>
                    </div>
                    <div v-if="formData.show_license" class="form_upload position_relative">
                        <Icon class="form_icon" size="20" type="ios-close-circle" color="#f00" @click.stop="delImg(2)"/>
                        <img class="form_img" :src="formData.show_license" @click="previewImg(formData.show_license)">
                    </div>
                </div>
            </FormItem>
            <FormItem label="其他资质：">
                <div class="form_upload mb24" @click="openModal(0, 3)">
                    <Icon type="ios-add" size="40" color="#AEAEB3"/>
                </div>
                <div class="img-div">
                    <div v-for="(item, index) in show_other" :key="index">
                        <div class="form_upload position_relative mr24 mb24">
                            <Icon class="form_icon" size="20" type="ios-close-circle" color="#f00" @click.stop="delImg(3, index)"/>
                            <img class="form_img" :src="item" @click="previewImg(item)">
                        </div>
                    </div>
                </div>
            </FormItem>
            <FormItem label="公司图片：">
                <div class="form_upload mb24" @click="openModal(0, 4)">
                    <Icon type="ios-add" size="40" color="#AEAEB3"/>
                </div>
                <div class="img-div">
                    <div v-for="(item, index) in show_pic" :key="index">
                        <div class="form_upload position_relative mr24 mb24">
                            <Icon class="form_icon" size="20" type="ios-close-circle" color="#f00" @click.stop="delImg(4, index)"/>
                            <img class="form_img" :src="item" @click="previewImg(item)">
                        </div>
                    </div>
                </div>
            </FormItem>
            <FormItem label="公司负责人：">
                <Input class="w300" type="text" v-model="formData.contact" placeholder="请输入公司负责人"></Input>
            </FormItem>
            <FormItem label="负责人联系方式：">
                <Input class="w300" type="text" v-model="formData.mobile" placeholder="请输入负责人联系方式"></Input>
            </FormItem>
            <FormItem label="公司联系地址：">
                <Input class="w300" type="text" v-model="formData.address" placeholder="请输入公司联系地址"></Input>
            </FormItem>
            <FormItem label="公司简介：">
                <Input class="w300" type="textarea" v-model="formData.desc" :autosize="{minRows: 3,maxRows: 6}" placeholder="请输入公司简介"></Input>
            </FormItem>
             <FormItem label="版权标识：">
                <Input class="w300" type="text" v-model="formData.copyright" placeholder="请输入版权标识"></Input>
            </FormItem>
            <div class="footer">
                <Button class="theme-bc ml24 theme-default-color" @click="submitForm">确定</Button>
            </div>
        </Form>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="imgtype"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import { system_company_index, system_company_save } from '@/api/index';
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
export default {
    components: { pictureLibrary },
    data() {
        return {
            srctype: "",
            imgtype: 1,
            switch_modal: false,
            formData: {
                company_name: "",
                logo: "",
                license: "",
                other: "",
                contact: "",
                mobile: "",
                address: "",
                pic: "",
                desc: "",
                show_logo: "",
                show_license: "",
                copyright: "",
            },
            show_other: [],
            show_pic: [],
            otherList: [],
            picList: [],
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.imgtype == 1) {
                for (var i = 0; i < param1.length; i++) {
                    this.formData.show_logo = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.formData.logo = param2[i];
                }
                this.$Message.destroy();
            }else if(this.imgtype == 2) {
                for (var i = 0; i < param1.length; i++) {
                    this.formData.show_license = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.formData.license = param2[i];
                }
                this.$Message.destroy();
            }else if(this.imgtype == 0 && this.srctype == 3) {
                for (var i = 0; i < param1.length; i++) {
                    this.show_other.push(param1[i]);
                }
                for (var i = 0; i < param2.length; i++) {
                    this.otherList.push(param2[i]);
                }
                this.$Message.destroy();
            }else if(this.imgtype == 0 && this.srctype == 4) {
                for (var i = 0; i < param1.length; i++) {
                    this.show_pic.push(param1[i]);
                }
                for (var i = 0; i < param2.length; i++) {
                    this.picList.push(param2[i]);
                }
                this.$Message.destroy();
            }
        },
        openModal(e, index) {
            this.imgtype = e;
            this.srctype = index;
            this.switch_modal = true;
        },
        getList(){
            system_company_index().then((res) => {
                if(res.data && res.data.length != 0){
                    this.formData.company_name = res.data.company_name;
                    this.formData.logo = res.data.logo;
                    this.formData.license = res.data.license;
                    this.formData.other = res.data.other;
                    this.formData.contact = res.data.contact;
                    this.formData.mobile = res.data.mobile;
                    this.formData.address = res.data.address;
                    this.formData.copyright = res.data.copyright;
                    this.formData.pic = res.data.pic;
                    this.formData.desc = res.data.desc;
                    if(res.data.logo){
                        this.formData.show_logo = res.data.show_logo;
                    }
                    if(res.data.license){
                        this.formData.show_license = res.data.show_license;
                    }
                    localStorage.setItem('companyData', JSON.stringify(res.data));
                    if(res.data.other){
                        this.otherList = res.data.other.split(',');
                    }
                    if(res.data.pic){
                        this.picList = res.data.pic.split(',');
                    }
                    this.show_other = res.data.show_other;
                    this.show_pic = res.data.show_pic;
                }
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 确定（提交表单）
        submitForm(){
            this.formData.other = this.otherList.join(',');
            this.formData.pic = this.picList.join(',');
            system_company_save(this.formData).then( res => {
                this.getList();
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        // 移动时
        onStart(e) {
            this.drag = true;
            console.log("触发移动", e);
        },
        // 移动结束
        onEnd(e) {
            this.drag = false;
            console.log("移动结束", e);
        },
        delImg(e, index){
            if(e == 1){
                this.formData.logo = ''
                this.formData.show_logo = ''
            }else if(e == 2){
                this.formData.license = ''
                this.formData.show_license = ''
            }else if(e == 3){
                this.otherList.splice(index, 1);
                this.show_other.splice(index, 1);
            }else if(e == 4){
                this.picList.splice(index, 1);
                this.show_pic.splice(index, 1);
            }
        },
        // 预览图片
        previewImg(item){
            if(item){
                window.open(item);
            }
        },
    },
};
</script>

<style scoped>
.container {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    position: relative;
}
.form_upload {
    width: 70px;
    height: 70px;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px solid #9FA5BB;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.form_img {
    width: 68px;
    height: 68px;
    border-radius: 5px;
}
.footer {
    margin: 24px 0 0 0;
    padding: 24px 0 0 0;
    text-align: center;
    border-top: 1px solid #eee;
}
.img-div {
    display: flex;
    flex-wrap: wrap;
}
.position_relative {
    position: relative;
}
.form_icon {
    position: absolute;
    top: -10px;
    right: -10px;
}
.image-div {
    display: flex;
    align-items: center;
}
</style>